import { render, staticRenderFns } from "./ProjectPlanningPeople.vue?vue&type=template&id=213754b6"
import script from "./ProjectPlanningPeople.vue?vue&type=script&lang=js"
export * from "./ProjectPlanningPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports